module.exports = __webpack_public_path__ + "media/images/gifts/open_end/sug_aberto_13-33db0a895e9a61aae3fade476d12ffa9.jpg";